import { Switch, SwitchMobile } from '../../../../switch-language';
import { FacebookURL, InstagramURL, LinkedInURL, SocialMedia, YoutubeURL } from '@damianxkozar/avionaut-ui';
import React, { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import { getLink } from '@helpers/linking.helper';
import { PageType } from '@constants/pageType.constants';

import s from './MobileMenu.module.scss';
import { ShopOnlineURL } from '@helpers/shop-online.helper';
import Shop from '@assets/svg/shop.svg';

interface IMobileMenu {
  setIsMenuDisplay: Dispatch<SetStateAction<boolean>>;
  multilingualSlugsForStaticPages: any;
  multilingualSlugsForCmsArticle: any;
}

const MobileMenu = ({
                      setIsMenuDisplay,
                      multilingualSlugsForStaticPages,
                      multilingualSlugsForCmsArticle,
                    }: IMobileMenu) => {
  const intl = useIntl();

  return (
    <div className={s.mobileMenu__placeholder}>
      <a className={s.mobileMenu__menu}>
        <a href={getLink(intl.locale, PageType.CAR_SEATS)}
           className={s.mobileMenu__link}
           onClick={() => setIsMenuDisplay(state => !state)}
        >
          {intl.formatMessage({ id: 'navbar__carSeats' })}
        </a>
        <a href={`${getLink(intl.locale, PageType.CAR_SEATS)}/sirius`}
           className={s.mobileMenu__link}
           onClick={() => setIsMenuDisplay(state => !state)}
        >
          {intl.formatMessage({ id: 'hpProducts__strollers_title' })}
        </a>
        <div onClick={() => setIsMenuDisplay(state => !state)}>
          <a href={getLink(intl.locale, PageType.KNOWLEDGE_BASE)}
             className={s.mobileMenu__link}
          >
            {intl.formatMessage({ id: 'navbar__knowledgeBase' })}
          </a>
        </div>
        <div onClick={() => setIsMenuDisplay(state => !state)}>
          <a href={getLink(intl.locale, PageType.CONTACT)}
             className={`${s.mobileMenu__link} ${s.mobileMenu__separation}`}
          >
            {intl.formatMessage({ id: 'navbar__contact' })}
          </a>
        </div>
        
          <div className={s.mobileMenu__shop}>
            {(intl.locale === 'fr' || intl.locale === 'pl' || intl.locale === 'de') && <a href={ShopOnlineURL[intl.locale]} target={'_blank'}
                className={s.mobileMenu__button}
            >
              <Shop className={s.mobileMenu__shopico}/>
              {intl.formatMessage({ id: 'navbar__shopOnline' })}
            </a>}
            <Switch multilingualSlugsForStaticPages={multilingualSlugsForStaticPages}
                    multilingualSlugsForCmsArticle={multilingualSlugsForCmsArticle}/>
          </div>
      </a>
    </div>
  );
};

export default MobileMenu;
